import React, {Component} from 'react'
import DrawCalendar from './drawCalendar'
import {MonthCalendar, LineMonthCalendar} from './functionsCalendar'

import forward from './forward.svg';
import backward from './backward.svg';

const Backward = ({m, y, viewStart, onClickMove}) =>{
  const vm = viewStart.getMonth()
  const vy = viewStart.getFullYear()
  const dateM = new Date(y, m - 1, 1)
  const dateV = new Date(vy, vm, 1)
  if (dateM >= dateV){
    return (
      <img src={backward} className="calendar-backward" alt="backward"
          onClick={() => onClickMove(LineMonthCalendar(m - 1, y)[0])}/>
    )
  }else {
    return (
      <div className="calendar-backward"/>
    )
  }
}

const Month = (props) =>{
  return (
    <div className='col-md-6'>
      <DrawCalendar {...props}/>
    </div>
  )
}

const Forward = ({m, y, viewEnd, onClickMove}) =>{
  const vm = viewEnd.getMonth()
  const vy = viewEnd.getFullYear()
  const dateM = new Date(y, m + 1 , 1)
  const dateV = new Date(vy, vm + 2, 1)

  if (dateM <= dateV){
    return (
      <img src={forward} className="calendar-forward" alt="forward"
          onClick={() => onClickMove(LineMonthCalendar(m + 1, y)[0])}/>
    )
  }else {
    return (
      <img src={forward} className="calendar-forward" alt="forward"
          onClick={() => onClickMove(LineMonthCalendar(m + 1, y)[0])}/>
    )
  }
}

class calendar extends Component{
  render(){
    const {onClickMove, onClickSelect, move, view, select, filter} = this.props
    const mSelect = (select!==undefined)?select:[]

    const now = new Date(Date.now());
    const y = parseInt((move === undefined) ? now.getFullYear(): move.year, 0)
    const m = parseInt((move === undefined) ? now.getMonth(): move.month, 0)

    const mView = (view!==undefined)?view:[]
    const viewStart = mView[0]
    const viewEnd = mView[1]

    const monthCalendar = MonthCalendar(m, y)
    return (
			<div className='calendar'>

        <Backward viewStart={viewStart} m={m} y={y} onClickMove={onClickMove}/>
        <div className='calendar-body'>
          {monthCalendar.map((item, index) => <Month key={index} index={index} month={item[0]} year={item[1]}
                          view={mView} select={mSelect} filter={filter} onClickSelect={onClickSelect}/>)}
        </div>
        <Forward viewEnd={viewEnd} m={m} y={y} onClickMove={onClickMove}/>

		  </div>
    )
  }
}

export default calendar



// WEBPACK FOOTER //
// ./src/shared/routes/components/calendar/calendar.js